
import "../styles/components/Text.css"

type TextType = "title" | "desc"

type TextFields = {
    type: TextType;
    content: string;
  };
  
  const CustomText: React.FC<TextFields> = ({ type, content }) => {
    return (
      <p className={type}>
        {content}
      </p>
    )
  };
  
  export default CustomText;
  